export interface GuideInterface {
  title: string;
  description: string;
  benefits: string[];
  steps: StepsGuide;
  advertisement?: string[];
  successTips: string[];
  additionalInfo: string[];
  promoTips?: string[];
}

interface StepsGuide {
  title: string;
  steps: SubStepsGuide[];
}

interface SubStepsGuide {
  description: string;
  subSteps?: SubSubStepsGuide[];
}

interface SubSubStepsGuide {
  description: string;
  subSubSteps?: string[];
}

export const supplierGuide: GuideInterface = {
  title: "Panduan Menjadi Supplier di BisnisLink",
  description:
    "BisnisLink adalah platform web-based yang membantu supplier memperluas jangkauan pasar, meningkatkan penjualan, dan menghemat waktu dan biaya. Platform ini menghubungkan supplier dengan ribuan reseller yang siap memasarkan produk Anda.",
  benefits: [
    "Akses langsung ke jaringan reseller yang luas: Produk Anda akan dipasarkan oleh ribuan reseller di seluruh Indonesia.",
    "Meningkatkan penjualan: Penjualan Anda akan meningkat dengan terhubung ke banyak reseller potensial.",
    "Menghemat waktu dan biaya: BisnisLink membantu Anda memasarkan produk dengan mudah dan hemat biaya.",
    "Transparansi dalam pengelolaan stok dan transaksi",
  ],
  steps: {
    title: "Langkah-Langkah Menjadi Supplier di BisnisLink",
    steps: [
      {
        description: "Pendaftaran",
        subSteps: [
          { description: "Buka website BisnisLink" },
          { description: "Klik 'Masuk/Daftar' dan pilih 'Supplier'." },
          {
            description:
              "Klik 'Buat Akun Supplier' Kemudian ikuti Langkah-langkahnya. Mudah Kok. Untuk Supplier disarankan untuk Pilih yang 'Buat Akun Supplier', kemudian lengkapi data yang dibutuhkan.",
          },
          { description: "Atau, Masuk menggunakan akun Google Anda." },
          {
            description:
              "Masukkan kode verifikasi yang dikirimkan ke email Anda.",
          },
          { description: "Anda telah resmi menjadi Supplier BisnisLink!" },
        ],
      },
      {
        description: "Menambahkan Produk",
        subSteps: [
          { description: "Lengkapi profil toko Anda." },
          { description: "Masukkan produk-produk yang ingin Anda jual." },
          {
            description:
              "Pastikan informasi produk lengkap dan akurat, termasuk:",
            subSubSteps: [
              "Foto produk",
              "Nama produk",
              "Kategori produk",
              "Deskripsi produk",
              "Harga produk",
              "Stok produk",
            ],
          },
        ],
      },
      {
        description: "Menjawab Pertanyaan Calon Pembeli",
        subSteps: [
          {
            description:
              "Jawab pertanyaan calon pembeli dengan cepat dan ramah.",
          },
          {
            description:
              "Berikan informasi yang jelas dan lengkap tentang produk Anda.",
          },
        ],
      },
      {
        description: "Memproses Pesanan",
        subSteps: [
          {
            description:
              "Kemas dan kirimkan produk setelah pembayaran terkonfirmasi.",
          },
          { description: "Gunakan jasa pengiriman yang dipilih oleh pembeli." },
          { description: "Upload nomor resi di halaman transaksi." },
          { description: "Setelah itu tinggal menunggu transaksi selesai." },
        ],
      },
      {
        description: "Menerima Pembayaran",
        subSteps: [
          {
            description:
              "Uang hasil penjualan akan masuk ke akun Supplier setelah barang diterima oleh pembeli.",
          },
          {
            description:
              "Ajukan pencairan dana hasil penjualan kepada admin BisnisLink.",
          },
        ],
      },
    ],
  },
  successTips: [
    "Pastikan produk Anda berkualitas tinggi dan kompetitif.",
    "Berikan harga yang menarik untuk reseller.",
    "Berikan layanan pelanggan yang excellent.",
    "Bangun hubungan yang baik dengan reseller.",
  ],
  additionalInfo: [
    "Anda dapat mengikuti pelatihan dan webinar yang disediakan oleh BisnisLink untuk meningkatkan kemampuan Anda sebagai supplier.",
    "Anda dapat bergabung dengan komunitas supplier BisnisLink untuk mendapatkan tips dan trik dari supplier lainnya.",
    "Anda dapat menggunakan fitur iklan di BisnisLink untuk meningkatkan visibilitas produk Anda kepada reseller.",
    "Anda dapat memberikan promo dan diskon kepada reseller untuk meningkatkan penjualan produk Anda.",
  ],
  promoTips: [
    "Gunakan foto produk yang menarik dan berkualitas tinggi.",
    "Buat deskripsi produk yang jelas dan informatif.",
    "Tawarkan harga yang kompetitif.",
    "Berikan promo dan diskon menarik.",
    "Ikut serta dalam program yang diadakan oleh BisnisLink.",
    "Bangun hubungan yang baik dengan reseller.",
  ],
};

export const resellerGuide: GuideInterface = {
  title: "Panduan Menjadi Reseller di BisnisLink",
  description:
    "BisnisLink adalah platform yang memungkinkan Anda untuk menjadi reseller dengan mudah dan hanya bermodalkan handphone. Anda dapat bekerja dari rumah dan mendapatkan keuntungan dengan menjual produk dari UMKM dan supplier terpercaya.",
  benefits: [
    "Tidak perlu stok barang, kami yang akan mengurus pengiriman langsung ke pelanggan Anda.",
    "Modal handphone saja",
    "Bisa dikerjakan dari rumah",
    "Akses ke berbagai produk dari UMKM dan supplier terpercaya",
    "Komisi menarik dari setiap penjualan",
    "Pencairan komisi mudah",
    "Menjadi reseller di BisnisLink GRATIS!",
  ],
  steps: {
    title: "Langkah-Langkah Menjadi Reseller di BisnisLink",
    steps: [
      {
        description: "Pendaftaran",
        subSteps: [
          { description: "Buka Website BisnisLink dan Klik “Masuk/Daftar”" },
          { description: "Kemudian Pilih dan Klik 'Reseller'." },
          {
            description:
              "Klik “Buat Akun Reseller” Kemudian ikuti Langkah-langkahnya. Mudah Kok.",
          },
          { description: "Atau Kamu bisa masuk menggunakan akun Google kamu." },
          {
            description:
              "Masukkan kode verifikasi yang dikirimkan ke nomor telepon Kamu.",
          },
          { description: "Kamu telah resmi menjadi Reseller BisnisLink!" },
        ],
      },
      {
        description: "Mencari Produk",
        subSteps: [
          {
            description:
              "Temukan produk yang ingin Kamu jual di katalog BisnisLink.",
          },
          { description: "Pilih produk dari UMKM atau supplier terpercaya." },
          {
            description:
              "Pastikan produk memiliki rating dan ulasan yang baik.",
          },
          {
            description:
              "Tambahkan produk ke 'Toko Saya' (Aktifkan tombol Tambah ke Toko Saya).",
          },
        ],
      },
      {
        description: "Mempromosi Produk secara aktif",
        subSteps: [
          {
            description:
              "Bagikan link produk di media sosial Kamu (Facebook, Instagram, Twitter, Tik Tok dll).",
          },
          { description: "Sebarkan link produk di status WhatsApp Kamu." },
          {
            description:
              "Berikan informasi yang jelas dan menarik tentang produk.",
          },
          { description: "Tawarkan diskon atau promo untuk menarik pembeli." },
        ],
      },
      {
        description: "Mendapatkan Komisi",
        subSteps: [
          {
            description:
              "Dapatkan komisi dari setiap penjualan yang terjadi melalui link Kamu.",
          },
          { description: "Komisi akan dihitung dan ditampilkan di akun Kamu." },
        ],
      },
      {
        description: "Pencairan Komisi",
        subSteps: [
          {
            description:
              "Kamu dapat mencairkan komisi setelah mencapai minimal saldo yang ditentukan.",
          },
          { description: "Pencairan komisi dilakukan melalui transfer bank." },
        ],
      },
    ],
  },
  successTips: [
    "Pilih produk yang sesuai dengan minat dan target pasar Kamu.",
    "Lakukan promosi produk secara kreatif dan inovatif.",
    "Berikan pelayanan yang baik kepada pelanggan.",
    "Bangun hubungan yang baik dengan UMKM dan supplier.",
  ],
  advertisement: [
    "BisnisLink - Modal Handphone, Bisnis Untung Berlipat!",
    "Mulai perjalanan Kamu sebagai reseller sukses sekarang!",
  ],
  additionalInfo: [
    "Anda dapat membuat toko online sendiri di BisnisLink untuk memudahkan pelanggan Anda berbelanja.",
    "Anda dapat mengikuti pelatihan dan E-Learning yang disediakan oleh BisnisLink untuk meningkatkan kemampuan Anda sebagai reseller.",
    "Anda dapat bergabung dengan komunitas reseller BisnisLink untuk mendapatkan tips dan trik dari reseller lainnya.",
  ],
};
